export enum AuctioneerType {
    AUCTIONEER = 'auctioneer',
    DEALER = 'dealer',
}
